import Vue from "vue";

export default class Object {
  initializeAttributes(attributes = {}, map = {}, initNullValues = true) {
    for (const prop in attributes) {

      if (attributes.hasOwnProperty(prop)) {

        
        let value = attributes[prop];
        const mapValue = map[prop];

        if (mapValue && (value != null || initNullValues)) {
          if (mapValue.prototype instanceof Object) {
            value = new mapValue(value);
          } else if (mapValue == Date) {
            if (value) {
              if (typeof value == "string") {
                const year = parseInt(value.substring(0, 4));
                const month = parseInt(value.substring(5, 7)) - 1;
                const day = parseInt(value.substring(8, 10));

                const hour =
                  value.length > 10 ? parseInt(value.substring(11, 13)) : 0;
                const minute =
                  value.length > 10 ? parseInt(value.substring(14, 16)) : 0;

                value = new Date(year, month, day, hour, minute);
              }
            }
          } else {
            value = mapValue(value);
          }
        }
        
        this[prop] = value;
      }
    }

    if (map && initNullValues) {
      for (const prop in map) {
        if (map.hasOwnProperty(prop)) {
          let mapValue = map[prop];

          if (mapValue) {
            if (mapValue.prototype instanceof Object) {
              if (this[prop] == null) {
                this[prop] = new mapValue();
              }
            }
          }
        }
      }
    }
  }

  static list(items) {
    let list = [];

    if (!items) return list;

    for (var i = 0; i < items.length; i++) {
      list.push(new this(items[i]));
    }

    return list;
  }

  toJSON() {
    const obj = {};

    for (const key in this) {
      if (this.hasOwnProperty(key)) {
        let value = this[key];

        if (
          !this.ignoreToJson ||
          (!this.ignoreToJson().includes(key) && !(value instanceof Vue))
        ) {
          if (value instanceof Object) {
            value = value.toJSON();
          }

          obj[key] = value;
        }
      }
    }

    return obj;
  }
}
